import axios from 'axios';
import leaveSSA from './leaveSSA';

export const onFullfilled = (response) =>
  // Interceptor handling a successful response
  response;

export const onRejected = async (error) => {
  // Interceptor handling a failed response
  if (
    !error.config ||
    !error.response ||
    error.response?.status !== 401 ||
    error.response.data?.errors?.length
  ) {
    return Promise.reject(error);
  }

  const url = `${error.config?.baseURL}${error.config?.url}`;

  if (!url.includes('aula.education') || url.includes('/auth/logout')) {
    return Promise.reject(error);
  }

  leaveSSA({ returnAfterLogin: true });

  return Promise.reject(error);
};

export default (instance) => {
  (instance || axios).interceptors.response.use(onFullfilled, onRejected);
};
